import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
var $ = require( "jquery" );


gsap.registerPlugin(ScrollTrigger);

// console.log('hello world');

var waterCard = document.querySelector('#water-card')
var fireCard = document.querySelector('#fire-card')
var wildCard = document.querySelector('#wild-card')
const burger = document.querySelector('.burger'); 
const burgerMenu = document.querySelector('.burger-menu'); 
const body = document.querySelector('body'); 
const burgerLinks = document.querySelectorAll('.burger-link');


burger.addEventListener('click', () => {
    burger.classList.toggle('open');
    burgerMenu.classList.toggle('open');
    body.classList.toggle('open');
});

var linkClick = function () {
  burgerLinks.forEach(link => {
    burger.classList.remove('open');
    burgerMenu.classList.remove('open');
    body.classList.remove('open');
  });
}

burgerLinks.forEach(link => {
  link.addEventListener('click', linkClick);
});


waterCard.addEventListener('mouseenter', () => {
    gsap.to(waterCard, {duration: 0.5, scale: 1.03, rotation: 0, y: -80, ease: "cubic-bezier(0.83, 0, 0.17, 1)"});
  });
  
  waterCard.addEventListener('mouseleave', () => {
    gsap.to(waterCard, {duration: 0.5, scale: 1, rotation: -30, y: 0, ease: "cubic-bezier(0.83, 0, 0.17, 1)"});
});

wildCard.addEventListener('mouseenter', () => {
    gsap.to(wildCard, {duration: 0.5, scale: 1.03, rotation: 0, y: -80, ease: "cubic-bezier(0.83, 0, 0.17, 1)"});
  });
  
  wildCard.addEventListener('mouseleave', () => {
    gsap.to(wildCard, {duration: 0.5, scale: 1, rotation: 30, y: 0, ease: "cubic-bezier(0.83, 0, 0.17, 1)"});
});

fireCard.addEventListener('mouseenter', () => {
    gsap.to(fireCard, {duration: 0.5, scale: 1.03, rotation: 0, y: 0, ease: "cubic-bezier(0.83, 0, 0.17, 1)"});
  });
  
  fireCard.addEventListener('mouseleave', () => {
    gsap.to(fireCard, {duration: 0.5, scale: 1, rotation: 0, y: 0, ease: "cubic-bezier(0.83, 0, 0.17, 1)"});
});